import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { CommentItem } from '../components/CommentItem';
import { PageHeader } from '../components/PageHeader';
import { PostCard } from '../components/PostCard';
import { Button } from '../components/ui/Button';
import { SectionTitle } from '../components/ui/Card';
import { EmptyState } from '../components/ui/EmptyState';
import { useLocale } from '../contexts/LocaleContext';
import { useSocial } from '../contexts/SocialContext';
export function PostDetail() {
  const {
    postId = ''
  } = useParams();
  const {
    t
  } = useLocale();
  const navigate = useNavigate();
  const social = useSocial();
  const post = social.posts.find(item => item.id === postId);
  if (!post) {
    return <div className="px-2 pb-2" data-id="element-3475" data-mp="osq8pod42gt3">
        <PageHeader title={t('post.title')} showBack data-id="element-3476" data-mp="otswvoj1u55b" />
        <EmptyState title={t('post.missing.title')} body={t('post.missing.body')} data-id="element-3477" data-mp="trkriqb2w5d7" />
      </div>;
  }
  const comments = social.commentsFor(post.id);
  return <div className="px-2 pb-2" data-id="element-3478" data-mp="5tzw4vur1vmg">
      <PageHeader title={t('post.title')} showBack data-id="element-3479" data-mp="tlnpcp8kjnw" />

      <PostCard post={post} clickable={false} data-id="element-3480" data-mp="s269irug2kj" />

      <section className="mt-3" data-id="element-3481" data-mp="3sx4oldp6ct45">
        <SectionTitle data-id="element-3482" data-mp="3syfqt92z1st5">{t('comments.title')}</SectionTitle>
        {comments.length === 0 ? <EmptyState title={t('comments.empty.title')} body={t('comments.empty.body')} data-id="element-3483" data-mp="3nzcy8o46hf22" /> : <ul className="rounded-card border border-sand-line bg-white/70 px-2" data-id="element-3484" data-mp="oi4vlr4diufg">
            {comments.slice(0, 2).map(comment => <CommentItem key={comment.id} comment={comment} data-id="element-3485" data-mp="kjpbpw3la269" />)}
          </ul>}
        <Button variant="outline" fullWidth className="mt-2" onClick={() => navigate(`/post/${post.id}/comentarios`)} data-id="element-3486" data-mp="forsxxgiceg6">
          {t('comments.seeAll', {
          n: social.commentCount(post.id)
        })}
          <ArrowRightIcon size={16} data-id="element-3487" data-mp="13fx8scmg76qh" />
        </Button>
      </section>
    </div>;
}